import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BET_SLIP_PLACED_TICKET_CHANGED } from '../../../store/actions/types';
import { getTranslation } from '../../../utils/translation';
import { printCoupon } from '../../../store/actions/betSlip';
import { generateCouponPrintDetails } from '../../../utils/helpers';
import Modal from '../../shared/Modal/Modal';
import ModalCloseButton from '../../shared/Modal/CloseButton/CloseButton';
import ModalIcon from '../../shared/Modal/Icon/Icon';
import ModalTitle from '../../shared/Modal/Title/Title';
import ModalButton from '../../shared/Modal/Button/Button';

const PlacedCoupon = props => {
    const dispatch = useDispatch();

    const placedTicketDetails = useSelector(state => state.betSlip.placedTicketDetails);
    const stakes = useSelector(state => state.betSlip.stakes);
    const cashierInfo = useSelector(state => state.auth.cashierInfo);

    const { resetBetSlip } = props;

    const resetPlacedTicket = () => {
        dispatch({
            type: BET_SLIP_PLACED_TICKET_CHANGED,
            payload: null,
        });
    };

    const hideModal = () => {
        resetPlacedTicket();
        resetBetSlip();
    };

    const onRetainSelections = () => {
        resetPlacedTicket();
    };

    const onReprintClick = async () => {
        const couponDetails = generateCouponPrintDetails({
            couponData: placedTicketDetails,
            stakes,
            cashierCode: cashierInfo.code,
        });
        await printCoupon(couponDetails);
    };

    return (
        <Modal isVisible width='476px' textAlign='center' contentPadding='50px 0'>
            <ModalCloseButton onClick={hideModal} />
            <ModalIcon className={'m-t-6'} iconKey='success' />
            <ModalTitle>{getTranslation('couponGeneratedModalTitle')}</ModalTitle>
            <ModalTitle>{placedTicketDetails.couponNumber}</ModalTitle>
            <div className={'flex justify-center m-t-8'}>
                <ModalButton
                    className={'m-r-6'}
                    type='submit'
                    onClick={onRetainSelections}
                    width='180px'
                    title={getTranslation('betSlip.actions.retainSelections')}
                />
                <ModalButton
                    secondary
                    onClick={onReprintClick}
                    width='180px'
                    title={getTranslation('ticketInformationReprintButton')}
                />
            </div>
        </Modal>
    );
};

export default PlacedCoupon;
